import {Provider} from "./provider";
import {log} from "../../util/log";


export class AndroidProvider extends Provider {
    /* STATIC */

    /* INSTANCE */
    override configure(value: boolean) {
        const iface = (window as any)['ConsentModeCMPInterface'];
        if (iface) {
            iface.configure(value);
        } else {
            log.debug('ConsentModeCMPInterface not found');
        }
    }
}
